export const translations = {
	nav: {
		title: 'Navigation',
		app: 'Certificat de don',
	},
	footer: {
		poweredBy: 'Créé par',
		copyright: '© {{year}} WorldCoo. Tous droits réservés.',
		termsAndConditions: 'Conditions générales',
		privacyPolicy: 'Politique de confidentialité',
	},
	categories: {
		basicNeeds: 'Eau et Énergie',
		humanRights: "Droits de l'Homme",
		education: 'Éducation',
		emergency: 'Urgences',
		feeding: 'Faim et Sécurité Alimentaire',
		environment: 'Environnement',
		habitat: 'Logement et Pauvreté',
		health: 'Santé',
	},
	statistics: {
		campaigns: 'Campagnes',
		donations: 'Dons',
		collected: 'Collecté',
		collectedFromBudget: 'Objectif de {{budget}}',
	},
	filters: {
		year: 'Année',
		state: 'État',
		cause: 'Cause',
		active: 'Active',
		finished: 'Terminée',
		default: 'Par défaut',
		toggle: 'Basculer {{value}}',
	},
	actions: {
		close: 'Fermer',
		search: "Rechercher n'importe quoi",
		filter: 'Filtrer',
		viewCampaign: 'Voir la campagne',
		makeDonation: 'Faire un don',
		donate: 'Donner',
		selectLanguage: 'Sélectionner la langue',
		backToHome: "Retour à l'accueil",
		funded: 'Financé',
		clear: 'Effacer les filtres',
		apply: 'Appliquer',
		goBack: 'Retour',
		previous: 'Précédent',
		next: 'Suivant',
	},
	portal: {
		heroButton: 'Commencer à donner',
		campaigns: {
			title: 'Campagnes',
			description: 'Explorez nos initiatives et choisissez la cause qui vous inspire le plus',
			notFound: 'Aucune campagne',
		},
		campaignFunded: 'Campagne financée',
		percentageFunded: '{{percentage}}% Financée',
		aCampaignFrom: 'Une campagne de : {{ngoName}}',
		beneficiaries: 'Bénéficiaires',
		directBeneficiaries: '{{count}} directs',
		indirectBeneficiaries: '{{count}} indirects',
		sdgs: {
			title: 'Objectifs de Développement Durable',
			1: 'Pas de Pauvreté',
			2: 'Faim Zéro',
			3: 'Bonne Santé et Bien-être',
			4: 'Éducation de Qualité',
			5: 'Égalité entre les Sexes',
			6: 'Eau Propre et Assainissement',
			7: "Énergie Propre et d'un Coût Abordable",
			8: 'Travail Décent et Croissance Économique',
			9: 'Industrie, Innovation et Infrastructure',
			10: 'Inégalités Réduites',
			11: 'Villes et Communautés Durables',
			12: 'Consommation et Production Responsables',
			13: 'Mesures Relatives à la Lutte contre les Changements Climatiques',
			14: 'Vie Aquatique',
			15: 'Vie Terrestre',
			16: 'Paix, Justice et Institutions Efficaces',
			17: 'Partenariats pour la Réalisation des Objectifs',
		},
	},
	faq: {
		title: 'Questions fréquentes',
		description: 'Réponses aux questions les plus courantes de nos donateurs.',
	},
	campaign: {
		objectives: 'Objectifs de la campagne',
		description: 'Description',
		activities: 'Activités',
		beneficiaries: 'Qui en bénéficiera ?',
		updatesAndLinks: "Plus d'informations et liens",
		from: 'Du:',
		until: 'Au:',
	},
	campaigns: {
		notTranslated: "Ce projet n'est pas encore disponible dans votre langue.",
	},
	placeholders: {
		amount: 'Autre montant',
	},
	donate: {
		title: 'Faites votre don',
		details: {
			title: 'Ajoutez vos données pour continuer',
			subtitle:
				'Complétez vos données pour finaliser votre don. Vous pouvez également demander votre certificat fiscal ici.',
		},
		certificate: {
			title: 'Récupérez jusqu’à {{amount}}',
			subtitle: 'Certifiez votre don en un clic et il apparaîtra automatiquement dans votre déclaration de revenus.',
		},
	},
	errors: {
		required: 'Ce champ est obligatoire',
		invalidExtref: 'Le code est invalide, il doit suivre ce format : {{format}}',
		email: "L'adresse e-mail est mal formatée.",
		emailAlreadyExists: 'Cet e-mail est déjà utilisé.',
		password: 'Votre mot de passe doit comporter 6 caractères ou plus.',
		confirmationCode: 'Veuillez saisir le code de confirmation.',
		documentType: 'Type de document invalide',
		termsAndConditions: 'Vous devez accepter les termes et conditions',
		amount: 'Veuillez sélectionner ou saisir un montant valide.',
		signIn: 'Erreur lors de la connexion',
		emailsDoNotMatch: 'Les adresses e-mail ne correspondent pas.',
		passwordsDoNotMatch: 'Les mots de passe ne correspondent pas.',
		imageFormat: 'Veuillez déposer un fichier image',
		camera: 'Impossible d’accéder à la caméra. Veuillez vous assurer d’avoir accordé l’autorisation.',
		expiredCode: 'Le code a expiré.',
		codeMismatch: 'Le code est incorrect. Veuillez réessayer.',
		notAuthorized: 'Identifiants incorrects. Veuillez réessayer.',
		userDoesNotExist: "L'utilisateur n'existe pas.",
		userNotConfirmed: "Utilisateur non confirmé. Veuillez d'abord confirmer votre adresse e-mail.",
		userAlreadyConfirmed: "L'utilisateur a déjà été confirmé.",
		documentNumberExists: 'Le numéro de document est déjà utilisé.',
		limitExceeded: 'Vous avez atteint la limite de tentatives. Veuillez réessayer plus tard.',
		invalidPassword:
			'Le mot de passe est invalide, il doit comporter au moins 6 caractères et ne peut pas contenir d’espaces.',
		captchaFailed: 'CAPTCHA verification failed. Please try again.',
		internal: 'Désolé, un problème est survenu, notre équipe a déjà été informée, veuillez réessayer plus tard.',
	},
	documentTypes: {
		id: 'CNI',
		passport: 'Passeport',
		taxId: 'Identification fiscale',
		nie: 'NIE',
		others: 'Autres',
	},
	labels: {
		code: 'Code',
		email: 'E-mail',
		repeatEmail: 'Répétez votre e-mail',
		password: 'Mot de passe',
		confirmPassword: 'Confirmer le mot de passe',
		amount: 'Montant du don',
		documentType: 'Type de document',
		documentNumber: 'Numéro de document',
		name: 'Nom',
		lastName: 'Prénom',
		streetName: 'Nom de la rue',
		streetNumber: 'Numéro',
		additionalInfo: 'Informations supplémentaires',
		postalCode: 'Code postal',
		city: 'Ville',
		country: 'Pays',
		region: 'Région',
		province: 'Province',
		certificate: 'Je souhaite recevoir un certificat fiscal',
		termsAndConditions1:
			"Ces informations ne seront partagées qu'avec les organisations bénéficiaires de vos dons afin de générer le certificat fiscal correspondant. Lisez les ",
		termsAndConditions2: 'termes et conditions',
		language: 'Langue',
		newsletter:
			'Abonnez-vous pour rester informé des causes que nous soutenons, des projets que nous finançons et des personnes que nous aidons dans le monde entier.',
	},
	checkout: {
		title: 'Méthode de paiement',
	},
	recaptcha: {
		description: 'protégé par reCAPTCHA.',
		privacy: 'Confidentialité',
		terms: 'Termes',
	},
	thanks: {
		title: 'Merci\n pour votre don !',
		description:
			'Vous recevrez bientôt un e-mail de confirmation avec tous les détails. Ensemble, nous construisons un avenir meilleur !',
	},
	termsAndConditions: {
		title: 'Conditions de Protection des données',
		labelText: "J'ai lu, compris et accepte les conditions de ",
		labelLink: 'Protection des Données de {{name}}',
		accept: "J'ai lu, compris et accepte",
		responsible: {
			title: 'Responsable',
			description: 'WORLDCOO S.L.',
		},
		purpose: {
			title: 'Finalité',
			description:
				"Gérer la relation commerciale dans tous ses domaines, ainsi que votre don et votre demande de certificat, et l'envoi de communications commerciales par voie électronique.",
			descriptionNgo:
				"La collecte de fonds pour les projets de l'ONG, vous tenir informé de l'ONG et de l'évolution du projet pour lequel vous avez fait un don et l'émission de certificats de déduction fiscale.",
		},
		legitimacy: {
			title: 'Légitimité',
			description: "La base légale pour le traitement de vos données est l'obtention de votre consentement.",
		},
		recipients: {
			title: 'Destinataires',
			description:
				"Les données ne seront pas transférées à des tiers sauf s'il existe une obligation légale de le faire.",
		},
		rights: {
			title: 'Droits',
			description:
				"Vous avez le droit d'accéder, de rectifier et de supprimer les données, ainsi que d'autres droits, comme expliqué dans les informations supplémentaires.",
		},
		additionalInfo: {
			title: 'Informations supplémentaires',
			description:
				'Vous pouvez consulter des informations supplémentaires et détaillées sur la Protection des Données sur notre page <a href="https://www.worldcoo.com/gdpr">web</a> ou en contactant <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a>.',
			descriptionNgo:
				'Vous pouvez consulter les informations supplémentaires et détaillées sur la Protection des Données sur le site web de chaque ONG.\n\n<b>{{ngoName}}</b>',
		},
	},
};
